"use client";
import { addToCart } from "@lib/data/cart";
import useToggleState from "@lib/hooks/use-toggle-state";
import type { StoreProductVariant, StoreRegion } from "@medusajs/types";
import ButtonCustom from "@modules/layout/components/button-custom";
import CartDrawer from "@modules/layout/components/cart-drawer";
import ContactButton from "@modules/layout/components/contact-button";
import { useParams, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { ExtendedStoreCart, ExtendedStoreProduct } from "types/global";

type ProductActionsProps = {
  product: ExtendedStoreProduct;
  region: StoreRegion;
  disabled?: boolean;
  cart: ExtendedStoreCart;
  isOutOfStock: boolean;
  cheapestPrice: any;
};

const optionsAsKeymap = (variantOptions: StoreProductVariant["options"]) => {
  return variantOptions?.reduce((acc: Record<string, string>, varopt: any) => {
    acc[varopt.option_id] = varopt.value;
    return acc;
  }, {});
};

function ProductActionsNew({ product, disabled, cart, isOutOfStock, cheapestPrice }: ProductActionsProps) {
  const [options, setOptions] = useState<Record<string, string | undefined>>({});
  const { state, close, toggle } = useToggleState();
  const [isBuyingNow, setIsBuyingNow] = useState(false);
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const countryCode = useParams().countryCode as string;
  const router = useRouter();
  const handleToggle = () => {
    setTimeout(() => toggle(), 1000);
  };

  useEffect(() => {
    if (product.variants?.length === 1) {
      const variantOptions = optionsAsKeymap(product.variants[0].options);
      setOptions(variantOptions ?? {});
    }
  }, [product.variants]);

  async function handleAddToCart(isBuyNow = false) {
    if (isBuyNow) setIsBuyingNow(true);
    else setIsAddingToCart(true);

    await addToCart({
      variantId: product.variants?.[0].id ?? "",
      quantity: 1,
      countryCode,
    });

    if (isBuyNow) {
      setIsBuyingNow(false);
      router.push("/checkout");
    } else {
      setIsAddingToCart(false);
      handleToggle();
    }
  }

  return (
    <>
      <div className="flex gap-4">
        {!isOutOfStock && cheapestPrice && (
          <>
            <ButtonCustom
              variant="secondary"
              className="flex-1"
              isLoading={isBuyingNow}
              disabled={isBuyingNow || isAddingToCart}
              onClick={() => handleAddToCart(true)}
            >
              Mua ngay
            </ButtonCustom>
            <ButtonCustom
              variant="primary"
              className="flex-1"
              isLoading={isAddingToCart}
              disabled={isAddingToCart || isBuyingNow}
              onClick={() => handleAddToCart(false)}
            >
              Thêm vào giỏ
            </ButtonCustom>
          </>
        )}
      </div>
      <ContactButton title="Chat với nhân viên tư vấn" platform="facebook" />
      <CartDrawer cart={cart} isOpen={state} onClose={close} />
    </>
  );
}

export default ProductActionsNew;
